(function ($) {

    var $productCardSlider,
        activeSlider = false;

    this.init = function () {
        this.ProductCards();
        if ($(".productcards-card").length > 0) {
            $(window).on("scroll", handleProductCardScroll);
        }

    };

    function handleProductCardScroll() {
        if (window.innerWidth > 991) {
            if (checkVisible()) {
                var timer = 0;
                $(".productcards-card").each(function () {
                    var $this = $(this);
                    window.setTimeout(function () {
                        $this.addClass("fadeInDown");
                    }, timer);
                    timer = timer + 100;
                });
            }
        }
    }

    function checkVisible() {
        var threshold = 0;
        var mode = 'visible';
        var elm = $(".productcards-card").first().get(0);


        var rect = elm.getBoundingClientRect();
        var viewHeight = Math.max(document.documentElement.clientHeight, window.innerHeight);
        var above = rect.bottom - threshold < 0;
        var below = rect.top - viewHeight + threshold >= 0;

        return mode === 'above' ? above : (mode === 'below' ? below : !above && !below);
    }

    /****************************************************************
     PRODUCT CARD SLIDER
    ****************************************************************/
    this.ProductCards = function () {
        $productCardSlider = $(".productcards .row");

        if (window.innerWidth < 992 && !activeSlider) {
            BuildProductCardSlider();
        }
        $(window).on("resize", function () {
            // if we re now less than 991, AND we are currently unslicked, THEN we need to rebuild the slider.
            if (window.innerWidth < 992 && !activeSlider) {
                BuildProductCardSlider();
            }
        });


        function BuildProductCardSlider() {

            activeSlider = true;

            $productCardSlider.slick({
                dots: true,
                centerMode: false,
                centerPadding: "50px",
                adaptiveHeight: true,
                autoplay: false,
                focusOnSelect: true,
                infinite: false,
                arrows: false,
                appendDots: $(".productcards-dots"),
                slidesToShow: 1,
                responsive: [
                    {
                        breakpoint: 9999,
                        settings: "unslick"
                    },
                    {
                        breakpoint: 992,
                        settings: {
                            dots: true,
                            autoplay: false
                        }
                    }
                ]
            });


            $productCardSlider.on("destroy", function () {
                activeSlider = false;

                // make sure that the buttons return to the normal tabindex
                $(".productcards-card-cta a").attr("tabindex", 0);

            });


            $productCardSlider.on("afterChange", function () {
                window.setTimeout(resetDots, 0);
            });

            resetDots();
        }
        function resetDots() {
            // reset the dots to say the correct thing
            $(".productcards .slick-dots li").each(function (index) {
                $(this).find("button").attr("aria-label", "show promotion " + (index + 1) + " of " + $(".productcards .slick-dots li").length);
            });
        }
    }

    this.init();

})(jQuery);